<template>
    <div>
        <PullRefresh v-model="isReFresh" @refresh="onRefresh">
            <List
                    style="height: 100%;padding: 5px;"
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    loading-text="拼命加载中..."
                    @load="onLoad"
                    :offset="50"
                    :immediate-check="true"
            >
                <DangerItem v-for="item in taskDangers" :key="item.id" :detail="item"  @delete="onDelete"/>
            </List>

            <Icon name="plus" size="35px" color="#fff" @click="$router.push(`/danger/PROSPECT/update/${taskId}`)"
                  class="float-btn-add"/>
        </PullRefresh>
    </div>
</template>

<script>
    import {Button, Icon, List, PullRefresh} from "vant"
    import TaskDangerInfo from "./TaskDangerInfo"
    import DangerItem from "../../danger/components/DangerItem"


    export default {
        components: {List, PullRefresh, DangerItem, TaskDangerInfo, Button, Icon},
        props: {},
        data() {
            return {
                taskId: this.$route.params.id,
                taskDangers: [],
                isReFresh: false,
                loading: false,
                finished: false,
            }
        },
        computed: {},
        created() {
        },
        mounted() {
        },
        methods: {
            onRefresh() {
                this.isReFresh = true;
                this.taskDangers = [];
                this.onLoad(true);
            },
            onLoad(isPullRefresh) {
                // this.$http.tokiot.prospect.taskDanger.list({
                this.$http.tokiot.safety.danger.list({
                    size: 20,
                    prospectTaskId: this.taskId
                    // page:this.taskDangers.length / 20 + 1
                })
                    .then(res => {
                        if (res) {
                            this.taskDangers.push(...res.rows);
                            this.loading = false;
                            if (isPullRefresh) this.isReFresh = false;
                            if (this.taskDangers.length >= res.total) {
                                this.finished = true;
                            }
                        }
                    })
            },
            onDelete(id){
                this.$http.tokiot.safety.danger.delete({id})
                    .then(ret=>{
                        if (ret){
                            this.$toast.success('删除成功')
                            this.onRefresh()
                        }
                    })
            }
        },
        watch: {}
    }

</script>

<style scoped>
    .float-btn-add {
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        bottom: 28px;
        right: 20px;
        z-index: 999;
        background: #1988fa;
        border-radius: 50%;
        /*box-shadow: 3px 3px 5px rgb(226, 225, 225);*/
    }


</style>